var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdentify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78772 10.7853H4.41483L4.55645 11.1302L5.91951 14.4504L5.91967 14.4508C5.96233 14.5542 5.91345 14.6695 5.81869 14.7129L4.62001 15.2353L4.61989 15.2353C4.53384 15.2729 4.42602 15.2353 4.38081 15.1306L3.08627 11.9796L2.94145 11.6271L2.67578 11.9003L0.559974 14.0765C0.55997 14.0765 0.559966 14.0765 0.559962 14.0765C0.498386 14.1398 0.428291 14.145 0.366302 14.1172C0.299083 14.087 0.25 14.0207 0.25 13.9369V3.44675C0.25 3.3578 0.300964 3.29386 0.37068 3.2649C0.441103 3.23565 0.508039 3.24962 0.553127 3.29986L0.552979 3.29999L0.559934 3.30715L7.50358 10.4493L7.50352 10.4493L7.50836 10.4541C7.56461 10.5089 7.57725 10.5863 7.54595 10.6626C7.514 10.7405 7.44951 10.7853 7.37766 10.7853H4.78772Z",
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_963_13254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 7.62858H8.625V5.37142H8.3125C8.13991 5.37142 8 5.23152 8 5.05892V4.3125C8 4.13991 8.13991 4 8.3125 4H10.0625C10.2351 4 10.375 4.13991 10.375 4.3125V7.62858H10.6875C10.8601 7.62858 11 7.76848 11 7.94108V8.6875C11 8.86009 10.8601 9 10.6875 9H8.3125C8.13991 9 8 8.86009 8 8.6875V7.94108C8 7.76848 8.13991 7.62858 8.3125 7.62858ZM9.5 1C8.87867 1 8.375 1.50367 8.375 2.125C8.375 2.74633 8.87867 3.25 9.5 3.25C10.1213 3.25 10.625 2.74633 10.625 2.125C10.625 1.50367 10.1213 1 9.5 1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_963_13254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 8,
    fill: "white",
    transform: "translate(8 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentify);
export default __webpack_public_path__ + "static/media/identify.87450fb1352f27188d832b05a6b2942e.svg";
export { ForwardRef as ReactComponent };